var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-container mt-2 mb-2"},[_c('div',{staticClass:"live-indicator"},[_c('span',{staticClass:"dot"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Recent visitors")])])])
}]

export { render, staticRenderFns }